const updateSearchTerm = (state, { payload: { searchTerm } }) => ({
  ...state,
  searchTerm,
});

export default updateSearchTerm;
